import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { compose } from 'redux'
import { withStyles } from '@material-ui/core'

import { isPricesPageSelector } from 'reduxModules/selectors/RouterSelectors'
import { dateSelector, dateRangeSelector } from 'reduxModules/selectors/DateSelectors'
import { isAlimanDispatcherSelector, isModultransPartnerSelector } from 'reduxModules/selectors/UserSelectors'
import { routeTypeSelector } from 'reduxModules/selectors/RouteSelectors'
import { dateActions } from 'reduxModules/actions/DateActions'

import { CalendarBase } from './Calendar'

// import { styles } from ' ./styles'

const styles = () => ({
  paper: {
    maxWidth: 300
  },
  calendar: {
    border: 'none'
  }
})

const mapStateToProps = createStructuredSelector({
  date: dateSelector,
  routeType: routeTypeSelector,
  dateRange: dateRangeSelector,
  isPricesPage: isPricesPageSelector,
  isAlimanDispatcher: isAlimanDispatcherSelector,
  isModultransPartner: isModultransPartnerSelector,
})

const mapDispatchToProps = {
  selectDate: dateActions.selectDate
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const Calendar = enhance(CalendarBase)



// WEBPACK FOOTER //
// ./src/components/Calendar/index.js